export default {
  sales: [],
  loading: false
}



// WEBPACK FOOTER //
// ./src/reports-aggrid/modules/sales-budget/state.js